import type { Message } from '../api/types';

/**
 * Reading the Messenger- and Instagram-specific parts of a message. The two
 * adapters record what arrived under `contentAttributes.messenger` and
 * `contentAttributes.instagram` respectively — one shape, two keys — and the
 * bubble only ever needs to know a few things about either.
 */
export interface MetaAttributes {
  /** A reply typed in the Page inbox, the Business Suite or the Instagram app — not sent from here. */
  echo?: boolean;
  unsupported?: boolean;
  /** An Instagram unsend: the words are gone, the row stays. */
  unsent?: boolean;
  quickReplyPayload?: string;
  postback?: { title?: string | null; payload?: string | null };
  /** Somebody else's content shared into the thread, when it could not be fetched as a file. */
  shares?: { type: string; url: string | null; title: string | null }[];
  /** An Instagram story the contact replied to. */
  storyReply?: { id: string | null; url: string };
}

export const metaOf = (message: Message): MetaAttributes =>
  (message.contentAttributes.messenger as MetaAttributes | undefined) ??
  (message.contentAttributes.instagram as MetaAttributes | undefined) ??
  {};

/** Whether this outgoing message was typed somewhere other than this console. */
export const isMetaEcho = (message: Message): boolean => !!metaOf(message).echo;
